import { render, staticRenderFns } from "./TableField.vue?vue&type=template&id=04c50c9b&scoped=true&"
import script from "./TableField.vue?vue&type=script&lang=js&"
export * from "./TableField.vue?vue&type=script&lang=js&"
import style0 from "./TableField.vue?vue&type=style&index=0&id=04c50c9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c50c9b",
  null
  
)

export default component.exports